var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenBoxAttempt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0676 12.1551C15.976 12.1551 18.3337 9.80702 18.3337 6.91055C18.3337 4.01407 15.976 1.66602 13.0676 1.66602C10.1593 1.66602 7.80157 4.01407 7.80157 6.91055C7.80157 8.25217 8.4139 9.2279 8.4139 9.2279L2.04566 15.5701C1.75991 15.8547 1.35985 16.5946 2.04566 17.2776L2.78046 18.0094C3.0662 18.2534 3.78465 18.5949 4.37249 18.0094L5.22975 17.1557C6.08701 18.0094 7.06674 17.5216 7.43414 17.0337C8.04647 16.1799 7.31168 15.3262 7.31168 15.3262L7.55661 15.0823C8.73228 16.2531 9.761 15.5701 10.1284 15.0823C10.7407 14.2285 10.1284 13.3747 10.1284 13.3747C9.88346 12.8869 9.39363 12.8869 10.0059 12.2771L10.7408 11.5452C11.3286 12.0331 12.5369 12.1551 13.0676 12.1551Z",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9045 6.91152C14.9045 7.92192 14.082 8.741 13.0675 8.741C12.0529 8.741 11.2305 7.92192 11.2305 6.91152C11.2305 5.90112 12.0529 5.08203 13.0675 5.08203C14.082 5.08203 14.9045 5.90112 14.9045 6.91152Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4053_19485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBoxAttempt);
export default __webpack_public_path__ + "static/media/OpenBoxAttempt.c989fceca01e373f07ddaafc0ec27969.svg";
export { ForwardRef as ReactComponent };